<template>
  <div class="landingpage_bg landingpage_header">
    <div class="banner_text_wrapper">
      <div class="header_title">
        VİVENSE NETWORK’E KATIL
      </div>
      <div class="header_title bold_text">
        TÜM TÜRKİYE’YE ULAŞ!
      </div>

      <div class="header_cta_wrapper">
        <router-link :to="{ name: 'applications.supplier' }">
          Tedarikçi Ol
        </router-link>
        <router-link :to="{ name: 'applications.seller' }">
          Satış Noktası Ol
        </router-link>
        <router-link :to="{ name: 'applications.carrier' }">
          Taşıyıcı Ol
        </router-link>
        <router-link :to="{ name: 'applications.interiorDesigner' }">
          İç Mimar Form
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeHeader',
};
</script>
